import { Injectable, Inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

import { TrackedBarcode } from './models/tracked-barcode.entity'
import { CrudService } from '../../services/crud.service'
import { SDKConfiguration, SDK_CONFIGURATION } from '../../models/config.model'

@Injectable({
  providedIn: 'root',
})
export class TrackedBarcodesService extends CrudService {
  constructor(
    @Inject(SDK_CONFIGURATION) config: SDKConfiguration,
    http: HttpClient,
  ) {
    super(
      config,
      http,
      `https://ai.evologi.it/api/barcode-eventi?environment=${config.apiUrl.toLowerCase().includes('staging') ? 'staging' : 'production'}`,
    )
  }

  // ============================================================================
  // CRUD Operations
  // ============================================================================

  /**
   * Create a trackedBarcode
   * @param trackedBarcodeId - The trackedBarcode ID
   * @param trackedBarcode - The trackedBarcode body to update
   * @returns The observable<TrackedBarcode> for update the trackedBarcode
   */
  create$(trackedBarcode: TrackedBarcode): Observable<number> {
    return this._createAndGetStatus$(trackedBarcode)
  }
}
